import { render, staticRenderFns } from "./BarChartNew.vue?vue&type=template&id=76133cff&"
import script from "./BarChartNew.vue?vue&type=script&lang=js&"
export * from "./BarChartNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports